import React, { useState } from 'react';
import { UI } from 'common';

const { WrappedRadioButton } = UI;

const DuplicatesAndErrors = ({ isDuplicatePage, importedData, setIsDuplicatesSaved }) => {
	const [selectedOption, setSelectedOption] = useState('0');
	const [duplicatesOrErrorList] = useState(
		isDuplicatePage ? importedData.importedDataDuplicates : importedData.importedDataErrors
	);
	const onRadioOptionChange = e => {
		setSelectedOption(e.value);
		setIsDuplicatesSaved({ isDuplicatesSaved: e.value === '0' });
	};

	return (
		<div className="duplicates-and-errors">
			<div className="primary-header">{isDuplicatePage ? 'Duplicates' : 'Errors'}</div>
			<br />
			{isDuplicatePage ? (
				<div>
					There are duplicates in your upload that match entries already in your
					Stamps.com contacts list.
					<br />
					<br />
					How do you want to handle the listed duplicates?
					<br />
					<br />
					<WrappedRadioButton
						key="input-option-allow"
						name="Allow"
						value="0"
						onChange={onRadioOptionChange}
						checked={selectedOption === '0'}
						dataqa="duplicates-and-errors-allow"
					>
						Allow Duplications
					</WrappedRadioButton>
					<WrappedRadioButton
						key="input-option-skip"
						name="skip"
						value="1"
						onChange={onRadioOptionChange}
						checked={selectedOption === '1'}
						dataqa="duplicates-and-errors-skip"
					>
						Skip Duplicates
					</WrappedRadioButton>
				</div>
			) : (
				<div>
					<p>
						The listed rows with identified errors will not be imported. Click{' '}
						<b>Complete Import</b> to finish importing your contacts without the errors.
					</p>
					<br />
					<br />
				</div>
			)}
			<div className="list">
				<b className="list-header">{isDuplicatePage ? 'Duplicates' : 'Errors'}</b>
				<hr className="horizontal-line" />
				<div className={isDuplicatePage ? 'duplicates-list-items' : 'errors-list-items'}>
					{duplicatesOrErrorList?.map((column, index) => (
						<div key={`item-${index}`}>
							<div className="left-panel" key={`left-label-${index}`}>
								{isDuplicatePage ? column.FullName : `Row ${column.RowId}`}
							</div>
							<div className="right-panel" key={`right-label-${index}`}>
								{isDuplicatePage ? column.Other : column.Info}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
export default DuplicatesAndErrors;
